/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CSSProperties} from "react";
import * as emotion from "emotion";
import {COLORS} from "@res/colors";
import {Spacing} from "@styles/styles";
import {
	BaseComponent,
	ThunderDispatcher
} from "@intuitionrobotics/thunderstorm/frontend";

export const dispatch_onProgress = new ThunderDispatcher<OnProgress, "__onProgress">("__onProgress");

export interface OnProgress {
	__onProgress: (key: string, ratio: number) => void;
}


const barStyle = emotion.css(
	{
		flex: 1,
		position: 'relative',
		minHeight: 3 * Spacing.xs,
		minWidth: 50,
		maxWidth: 150,
		backgroundColor: COLORS.color_gray_medium,
		overflow: 'hidden',
		borderRadius: Spacing.m
	}
);

type Props = {
	progressKey: string
	style?: CSSProperties,
	hideOnComplete?: boolean
}

type State = {
	ratio: number
}

export class ProgressBar
	extends BaseComponent<Props, State> implements OnProgress {

	constructor(props: Props) {
		super(props);

		this.state = {
			ratio: 0
		}
	}

	__onProgress = (key: string, ratio: number) => {
		if (key === this.props.progressKey && this.state.ratio < ratio)
			this.setState({ratio})
	}

	render() {
		if (this.props.hideOnComplete && this.state.ratio === 1)
			return null

		const startThreshold = 4; // For UI purpose only, help the user understand what he is about to see in the progress bar;
		return <div className={barStyle} style={{...this.props.style}}>
			<div className={'absolute match_height'} style={{
				top: 0,
				left: 0,
				backgroundColor: COLORS.primary_dark_blue,
				width: `max(${100 * this.state.ratio}%, ${startThreshold}px)`
			}}
			/>
		</div>
	}
}
